import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Product, ProductDetail } from '../../model/product.model';
import { ComparatorService } from '../../../core/services/comparator.service';

@Component({
  selector: 'raf-compare-button',
  templateUrl: './compare-button.component.html',
  styleUrls: ['./compare-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareButtonComponent {
  @Input()
  product?: Product | ProductDetail;

  @Input()
  edge?: 'left' | 'right';

  constructor(private comparatorService: ComparatorService) {}

  onClick() {
    if (this.product) {
      this.comparatorService.add(this.product);
    }
  }
}
